import script from "./Organization.vue?vue&type=script&setup=true&lang=ts"
export * from "./Organization.vue?vue&type=script&setup=true&lang=ts"

import "./Organization.vue?vue&type=style&index=0&id=65a1526a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a1526a"]])

export default __exports__